export const DICH_VU = 'dich_vu';
const ROUTER = {
  DEFAULT: '/',
  SVG_VIEWER: '/svg-viewer',
  RECEIVER: '/receiver',
  HOME: '/',
  UPLOADFILE: '/upload-file',
  DANG_NHAP: '/',
  DANG_KY: '/dang-ky',
  DOI_MAT_KHAU: '/doi-mat-khau',

  //ANONYMOUS
  SSO: '/sso',

  // ADMIN
  PQR_STANDARDS: '/pqr-standards',
  DASHBOARD: '/dashboard',
  EMAIL_MANAGEMENT: '/email-management',
  //request (dùng chung)
  REQUEST_MANAGEMENT: '/request-management',
  REQUEST_MANAGEMENT_CREATE: '/request-management/create',
  REQUEST_MANAGEMENT_DETAIL: '/request-management/detail',
  REQUEST_MANAGEMENT_UPDATE: '/request-management/update',
  REQUEST_MANAGEMENT_CREATE_TAB: '/request-management/create-tab',
  //request vung tau
  REQUEST_MANAGEMENT_VUNG_TAU: '/request-management-vts-vung-tau',
  TEST_MATERIAL: '/request-material-management-vts-vung-tau',
  TEST_PQR: '/request-pqr-management-vts-vung-tau',
  TEST_PRODUCTION: '/request-production-management-vts-vung-tau',
  TEST_BOLTS: '/request-bolts-management-vts-vung-tau',
  CALIBRATION_MEASURING_EQUIPMENT:
    '/calibration-equipment-management-vts-vung-tau',
  CALIBRATION_PSV: '/calibration-psv-management-vts-vung-tau',
  CALIBRATION_WELDING_MACHINE:
    '/calibration-welding-machine-management-vts-vung-tau',
  CALIBRATION_WIRE_FEEDER: '/calibration-wire-feeder-management-vts-vung-tau',

  //request bien hoa
  TEST_MATERIAL_BIEN_HOA: '/request-material-management-vts-bien-hoa',
  TEST_PQR_BIEN_HOA: '/request-pqr-management-vts-bien-hoa',
  TEST_PRODUCTION_BIEN_HOA: '/request-production-management-vts-bien-hoa',
  TEST_BOLTS_BIEN_HOA: '/request-bolts-management-vts-bien-hoa',
  CALIBRATION_MEASURING_EQUIPMENT_BIEN_HOA:
    '/calibration-equipment-management-vts-bien-hoa',
  CALIBRATION_PSV_BIEN_HOA: '/calibration-psv-management-vts-bien-hoa',
  CALIBRATION_WELDING_MACHINE_BIEN_HOA:
    '/calibration-welding-machine-management-vts-bien-hoa',
  CALIBRATION_WIRE_FEEDER_BIEN_HOA:
    '/calibration-wire-feeder-management-vts-bien-hoa',
  INSPECTION: '/request-inspection-management',
  MASTER_LIST: '/master-list',
  PROFILE_MANAGEMENT: '/profile-management',
  //Customers
  CUSTOMER_MANAGEMENT: '/customer-management',
  CUSTOMER_MANAGEMENT_DETAIL: '/customer-management',
  WELDER_MANAGEMENT: '/welder-management',
  REQUEST_CONFIG: '/report-form-templates',
  LEGACY_REQUEST_CONFIG: '/request-config',
  PAYMENT_MANAGEMENT: '/payment-management',
  PAYMENT_DOCUMENT_MANAGEMENT: '/payment-document-management',
  QUOTATION_MANAGEMENT: '/quotation-management',
  CONTRACT_MANAGEMENT: '/contract-management',
  // ====
  //Devices
  EQUIPMENT_TOOLS_MANAGEMENT: '/equipment-tools-management',
  CALIBRATION_EQUIPMENT_MANAGEMENT: '/calibration-equipment-management',
  EQUIPMENT_AND_MATERIALS_MANAGEMENT: '/equipment-and-materials-management',
  //=====
  PROPOSAL_MANAGEMENT: '/proposal-management',
  USER_MANAGEMENT: '/user-management',
  FILE_MANAGEMENT: '/file-management',
  ROLE_MANAGEMENT: '/role-management',
  PROCESS_INSSTRUCTION_MANAGEMENT: '/process-instruction-management',
  SUBCONTRACTOR_MANAGEMENT: '/subcontractor-management',
  TO_DO_LIST: '/to-do-list-vts-vung-tau',
  TO_DO_LIST_BIEN_HOA: '/to-do-list-vts-bien-hoa',
  COLUMN_MANAGEMENT: '/column-management',
  Schedule: '/schedule-vts-vung-tau',
  Schedule_BIEN_HOA: '/schedule-vts-bien-hoa',
  TICKET_MANAGEMENT: '/ticket-management',
  MY_TICKET: '/my-ticket',
  EMPLOYEE_ATTENDANCE: '/employee-attendance',
  ATTENDANC_SHEET: '/attendanc-sheet',
  EMPLOYEE_ATTENDANC_SHEET: '/Employee-attendanc-sheet',
  //User
  DICH_VU: DICH_VU,
  THONG_TIN_TAI_KHOAN: `/thong-tin-ca-nhan`,
};
export default ROUTER;
